import { render, staticRenderFns } from "./SectionBannerComponent.vue?vue&type=template&id=09678bfe&scoped=true"
import script from "./SectionBannerComponent.vue?vue&type=script&lang=js"
export * from "./SectionBannerComponent.vue?vue&type=script&lang=js"
import style0 from "./SectionBannerComponent.vue?vue&type=style&index=0&id=09678bfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09678bfe",
  null
  
)

export default component.exports